/* esm.sh - mainnet-js@4.0.0-next.4/dist/module/util/hash160 */
import{ripemd160 as r,sha256 as a}from"/@bitauth/libauth@^3.1.0-next.8?target=esnext";function s(h){return r.hash(a.hash(h))}export{s as hash160};
//# sourceMappingURL=hash160.mjs.map